import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserLight, UtilisateurService } from '../../../shared';

@Component({
  selector: 'app-validate-collab',
  templateUrl: './validate-collab.component.html',
  styleUrls: ['./validate-collab.component.scss'],
})
export class ValidateCollabComponent implements OnInit {
  codeValidation!: string;
  crpcen!: string;
  utilisateurToValidate!: UserLight;

  showFormCollabContent: boolean = true;
  codeValidationAlreadyValidated: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private utilisateurService: UtilisateurService,
  ) {}

  ngOnInit() {
    this.init();
  }

  private async init() {
    /** Récupérer le token depuis les paramètres + consultation du MS pour vérifier la validité */

    this.route.params.subscribe((params) => {
      this.codeValidation = params['token'];
    });

    try {
      this.utilisateurToValidate =
        await this.utilisateurService.getUtilisateurByCodeValidation(
          this.codeValidation,
        );

      this.crpcen = this.utilisateurToValidate.organizationCode;
    } catch (err: any) {
      this.showFormCollabContent = false;

      if (
        err?.error?.errors[0]?.message === 'Code_Validation_Already_Validated'
      ) {
        this.codeValidationAlreadyValidated = true;
      }
    }
  }
}
